// Entry helper: finds <section data-tool="name"> (rendered by the Fluid template
// of CType sitepackage_tool) and calls init(mountNode, config, section) once.

export function parseConfig(raw) {
  if (!raw) return {};
  try {
    const v = JSON.parse(raw);
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch (e) {
    return {};
  }
}

export function mount(name, init) {
  const run = () => {
    document.querySelectorAll(`[data-tool="${name}"]`).forEach((section) => {
      if (section.dataset.toolReady) return;
      section.dataset.toolReady = '1';
      let target = section.querySelector('.tool__mount');
      if (!target) {
        target = document.createElement('div');
        target.className = 'tool__mount';
        section.append(target);
      }
      try {
        init(target, parseConfig(section.dataset.config), section);
      } catch (e) {
        target.textContent = 'Der Rechner konnte nicht geladen werden.';
        // eslint-disable-next-line no-console
        console.error(`[tool:${name}]`, e);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
}
